"use strict";

export default class {
    constructor(dataObject = null) {
        this.Code = '';
        this.Name = '';
        this.Edition = '';
        this.Nationality = '';

        if (dataObject) {
            try {
                this.Code = dataObject.Code ?? dataObject.code ?? '';
                this.Name = dataObject.Name ?? dataObject.name ?? '';
                this.Edition = dataObject.Edition ?? dataObject.edition ?? '';
                this.Nationality =
                    dataObject.Nationality ?? dataObject.nationality ?? '';
            } catch (e) {
                throw 'Data import error @ CountryMaster data.';
            }
        }
    }
}
